import React, { Component } from "react";
//import { Link } from 'react-router-dom';
import { Translate, I18n } from "react-redux-i18n";
//import './styles/Home.css';
import { connect } from "react-redux";

class StoreSuscription extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }

  componentWillUnmount() { }

  render() {
    return (
      <div className="marketstore-sidebar-card">
        <div className="marketstore-sidebar-card-header">
          <Translate value="suscription_mine" />
        </div>
        <div className="marketstore-sidebar-card-body">
          {this.props.lang === "es" ? (
            <p className="marketstore-sidebar-stat">
              <strong>Conoce nuestras promociones, nuevos anuncios, rebajas y descuentos.</strong>
            </p>
          ) : (
            <p className="marketstore-sidebar-stat">
              <strong>Know our promotions, new ads, sales discounts.</strong>
            </p>
          )}

          <div className="mc-field-group">
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
            />
          </div>
          <div className="text-center" style={{ marginTop: "12px" }}>
            <button type="button" name="subscribe" className="marketstore-btn marketstore-btn--primary" disabled>
              <Translate value="suscription_subscribe" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    lang: reducer.i18n.locale
  };
}
export default connect(mapStateToProps, null)(StoreSuscription);
